import {
  CognitoAWSCredentialsAndIdentityIdProvider,
  DefaultIdentityIdStore,
  cognitoUserPoolsTokenProvider,
} from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';

import { PLATFORM } from '@packages/types';
import { amplifyConfigure } from '@packages/utils';

import { version } from '../../package.json';
import { WEB_AWS_CONFIG } from './awsConfig';

const cognitoCredentialsProvider = new CognitoAWSCredentialsAndIdentityIdProvider(
  new DefaultIdentityIdStore(sessionStorage),
);
amplifyConfigure(WEB_AWS_CONFIG, {
  API: {
    REST: {
      headers: async () => ({
        platform: PLATFORM.WEB,
        'x-app-version': version,
      }),
    },
  },
  Auth: {
    credentialsProvider: cognitoCredentialsProvider,
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

//remove cognito identity id from local storage to fix race condition due to having same identity on different tabs
const cognitoIdentityKey = Object.keys(localStorage).find(i =>
  i.startsWith(`com.amplify.Cognito.${import.meta.env.VITE_AWS_REGION ?? 'ap-southeast-2'}`),
);
if (cognitoIdentityKey) {
  localStorage.removeItem(cognitoIdentityKey);
}
